import { render, staticRenderFns } from "./snag.vue?vue&type=template&id=254129cc&scoped=true&"
import script from "./snag.vue?vue&type=script&lang=js&"
export * from "./snag.vue?vue&type=script&lang=js&"
import style0 from "./snag.vue?vue&type=style&index=0&id=254129cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254129cc",
  null
  
)

export default component.exports